import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { formatRM } from "@/data/products";
import { ProductImage } from "@/components/Products";

export default function ProductModal({ product, onClose, onAdd }) {
  return (
    <Dialog open={!!product} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-3xl p-0 overflow-hidden" data-testid="product-modal">
        {product && (
          <div className="grid md:grid-cols-2">
            <div className="aspect-square md:aspect-auto md:min-h-[420px] bg-white flex items-center justify-center p-6 border-b md:border-b-0 md:border-r border-[#e6e1d8]">
              <ProductImage product={product} />
            </div>
            <div className="p-7 md:p-9 flex flex-col">
              <DialogHeader className="text-left">
                <span className="text-xs font-bold tracking-widest uppercase text-[#0d7a72] mb-2" data-testid="modal-product-category">
                  {product.category}
                </span>
                <DialogTitle className="font-display text-2xl font-semibold text-[#10233f] leading-snug" data-testid="modal-product-name">
                  {product.name}
                </DialogTitle>
                <DialogDescription className="sr-only">Product details for {product.name}</DialogDescription>
              </DialogHeader>

              <p className="font-display text-2xl font-semibold text-[#10233f] mt-4 mb-6" data-testid="modal-product-price">
                {formatRM(product.price)}
              </p>

              <ul className="space-y-2.5 mb-6 flex-1" data-testid="modal-product-details">
                {product.details.map((d, i) => (
                  <li key={i} className="flex gap-2.5 text-sm text-[#5a6b85] leading-relaxed">
                    <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#0d7a72] shrink-0" />
                    {d}
                  </li>
                ))}
              </ul>

              {product.attribution && (
                <p className="text-xs text-[#8a97ad] mb-6" data-testid="modal-product-attribution">
                  {product.attribution}
                </p>
              )}

              <button
                onClick={() => onAdd(product.id)}
                data-testid="modal-add-to-cart-btn"
                className="w-full px-6 py-3.5 rounded-full bg-[#0d7a72] text-sm font-bold text-white hover:bg-[#0a5f59] transition-colors"
              >
                Add to Cart
              </button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
